import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex overflow-auto h-55px mt-5 mb-10" }
const _hoisted_2 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Estore ")
const _hoisted_5 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Transfer Product ")
const _hoisted_7 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Estore Transactions ")
const _hoisted_9 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Vote for Miss iGlow ")
const _hoisted_11 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ECC Order Claim ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/estore",
          class: "nav-link text-active-primary me-6",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (_ctx.isBCOAccount)
        ? (_openBlock(), _createBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/transferproduct",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isBCOAccount)
        ? (_openBlock(), _createBlock("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/estoretrans",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.votingON == true)
        ? (_openBlock(), _createBlock("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/votemsiglow",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createBlock("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/eccorderclaim",
              class: "nav-link text-active-primary me-6",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}